import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pBuyView.css';

const mockTransaction = {
  user: {
    name: 'Daniel Abraham',
    initial: 'D',
    verified: true,
    completionRate: '33.33%',
    orders: 1,
    avgTime: '15m',
    lastSeen: 'Last seen an hour ago'
  },
  price: '1575.55',
  currency: 'NGN',
  limitMin: '1600.00',
  limitMax: '7877.75',
  available: '5',
  paymentMethods: ['FBN', 'OPay', 'Palmpay']
};

const P2pBuyView: React.FC = () => {
  const navigate = useNavigate();
  const [buyMode, setBuyMode] = useState<'crypto' | 'fiat'>('crypto');
  const [cryptoAmount, setCryptoAmount] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('FBN');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="p2p-view-container">
      <header className="p2p-view-header">
        <button className="p2p-view-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="p2p-view-title">Buy USDT</h1>
      </header>

      <div className="p2p-view-content">
        <div className="p2p-view-user-card">
          <div className="p2p-view-user-avatar">
            {mockTransaction.user.initial}
          </div>
          
          <div className="p2p-view-user-info">
            <div className="p2p-view-user-name">
              {mockTransaction.user.name}
              {mockTransaction.user.verified && (
                <svg className="p2p-view-verified-badge" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 0L9.5 5.5L15 7L9.5 8.5L8 14L6.5 8.5L1 7L6.5 5.5L8 0Z" fill="#22c35d"/>
                </svg>
              )}
            </div>
            <div className="p2p-view-user-last-seen">{mockTransaction.user.lastSeen}</div>
          </div>

          <div className="p2p-view-user-stats">
            <div className="p2p-view-stat p2p-view-stat-completion">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              <span>{mockTransaction.user.completionRate}</span>
            </div>
            
            <div className="p2p-view-stat">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 1V7M6 1L2 5M6 1L10 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{mockTransaction.user.orders} orders</span>
            </div>
            
            <div className="p2p-view-stat">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6 3V6L8 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>{mockTransaction.user.avgTime}</span>
            </div>
          </div>
        </div>

        <div className="p2p-view-info-row">
          <div className="p2p-view-info-card">
            <div className="p2p-view-info-label">Available</div>
            <div className="p2p-view-info-value">{mockTransaction.available} USDT</div>
            <div className="p2p-view-info-sub">{mockTransaction.currency} {mockTransaction.limitMax}</div>
          </div>
          
          <div className="p2p-view-info-card">
            <div className="p2p-view-info-label">Limit</div>
            <div className="p2p-view-info-value-multi">
              {mockTransaction.currency} {mockTransaction.limitMin} - {mockTransaction.currency} {mockTransaction.limitMax}
            </div>
          </div>
        </div>

        <div className="p2p-view-payment-badges">
          {mockTransaction.paymentMethods.map((method, index) => (
            <div key={index} className="p2p-view-payment-badge">
              {method}
            </div>
          ))}
        </div>

        <div className="p2p-view-price-card">
          <div className="p2p-view-price-label">Price:</div>
          <div className="p2p-view-price-value">{mockTransaction.currency} {mockTransaction.price}</div>
        </div>

        <div className="p2p-view-buy-section">
          <div className="p2p-view-buy-header">
            <span className="p2p-view-buy-label">Buy With</span>
            <div className="p2p-view-buy-toggle">
              <button 
                className={`p2p-view-toggle-option ${buyMode === 'crypto' ? 'active' : ''}`}
                onClick={() => setBuyMode('crypto')}
              >
                Crypto Amount
              </button>
            </div>
          </div>

          <div className="p2p-view-buy-inputs">
            <div className="p2p-view-crypto-input">
              <div className="p2p-view-crypto-icon">₮</div>
              <span className="p2p-view-crypto-label">USDT</span>
            </div>

            <button className="p2p-view-swap-button" aria-label="Swap">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 10L7 14L7 2M13 6L9 2L9 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="p2p-view-amount-input">
              <input 
                type="text" 
                placeholder="0.00" 
                value={cryptoAmount}
                onChange={(e) => setCryptoAmount(e.target.value)}
                className="p2p-view-input"
              />
            </div>
          </div>
        </div>

        <div className="p2p-view-limit-info">
          Limit: {mockTransaction.currency} {mockTransaction.limitMin} {mockTransaction.currency} - {mockTransaction.currency} {mockTransaction.limitMax} {mockTransaction.currency}
        </div>

        <button className="p2p-view-payment-selector">
          <span>{selectedPayment}</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="p2p-view-terms">
          <label className="p2p-view-terms-label">
            <input 
              type="checkbox" 
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              className="p2p-view-checkbox"
            />
            <span className="p2p-view-terms-text">
              By continuing, you confirm that you have read and agree to the Coinsher P2P trading legal disclaimer
            </span>
          </label>
        </div>

        <button className="p2p-view-buy-button" disabled={!agreedToTerms}>
          Buy USDT
        </button>
      </div>
    </div>
  );
};

export default P2pBuyView;